var map = {
	"./geography/argentina.svg": "7464",
	"./geography/brazil.svg": "2341",
	"./geography/chile.svg": "91c0",
	"./geography/colombia.svg": "8577",
	"./geography/italy.svg": "53eb",
	"./geography/mobile/opacity-100/argentina.svg": "86de",
	"./geography/mobile/opacity-100/brazil.svg": "74ed",
	"./geography/mobile/opacity-100/chile.svg": "0076",
	"./geography/mobile/opacity-100/colombia.svg": "71e3",
	"./geography/mobile/opacity-100/italy.svg": "1e71",
	"./geography/mobile/opacity-100/peru.svg": "a58b",
	"./geography/mobile/opacity-100/romania.svg": "e331",
	"./geography/mobile/opacity-100/spain.svg": "1a35",
	"./geography/mobile/opacity-100/unitedStates.svg": "6643",
	"./geography/mobile/opacity-50/argentina.svg": "3898",
	"./geography/mobile/opacity-50/brazil.svg": "28a2",
	"./geography/mobile/opacity-50/chile.svg": "16ca",
	"./geography/mobile/opacity-50/colombia.svg": "72b2",
	"./geography/mobile/opacity-50/italy.svg": "6d76",
	"./geography/mobile/opacity-50/peru.svg": "4b85",
	"./geography/mobile/opacity-50/romania.svg": "3e2f",
	"./geography/mobile/opacity-50/spain.svg": "d4e1",
	"./geography/mobile/opacity-50/unitedStates.svg": "a9e1",
	"./geography/peru.svg": "641d",
	"./geography/romania.svg": "2894",
	"./geography/spain.svg": "8a6b",
	"./geography/unitedStates.svg": "6495",
	"./icon/backhome.svg": "607a",
	"./urbanEnvironments/buildings.svg": "b19f",
	"./urbanEnvironments/cityDistricts.svg": "0ab7",
	"./urbanEnvironments/crossRoads.svg": "9775",
	"./urbanEnvironments/culturalHeritage.svg": "6346",
	"./urbanEnvironments/culturalSites.svg": "3c50",
	"./urbanEnvironments/hospital.svg": "c795",
	"./urbanEnvironments/mobile/opacity-100/buildings.svg": "badd",
	"./urbanEnvironments/mobile/opacity-100/cityDistricts.svg": "6ba5",
	"./urbanEnvironments/mobile/opacity-100/crossRoads.svg": "6b8f",
	"./urbanEnvironments/mobile/opacity-100/culturalHeritage.svg": "27ce",
	"./urbanEnvironments/mobile/opacity-100/culturalSites.svg": "d94e",
	"./urbanEnvironments/mobile/opacity-100/hospital.svg": "8beb",
	"./urbanEnvironments/mobile/opacity-100/parkings.svg": "aefa",
	"./urbanEnvironments/mobile/opacity-100/publicTransport.svg": "40dd",
	"./urbanEnvironments/mobile/opacity-100/schoolUniversities.svg": "e504",
	"./urbanEnvironments/mobile/opacity-100/shoppingAreas.svg": "f402",
	"./urbanEnvironments/mobile/opacity-100/sportFacilities.svg": "7f47",
	"./urbanEnvironments/mobile/opacity-100/streets.svg": "af29",
	"./urbanEnvironments/mobile/opacity-50/buildings.svg": "3487",
	"./urbanEnvironments/mobile/opacity-50/cityDistricts.svg": "1988",
	"./urbanEnvironments/mobile/opacity-50/crossRoads.svg": "7704",
	"./urbanEnvironments/mobile/opacity-50/culturalSites.svg": "56bd",
	"./urbanEnvironments/mobile/opacity-50/hospital.svg": "c815",
	"./urbanEnvironments/mobile/opacity-50/parkings.svg": "d0a5",
	"./urbanEnvironments/mobile/opacity-50/publicTransport.svg": "ed51",
	"./urbanEnvironments/mobile/opacity-50/schoolUniversities.svg": "b868",
	"./urbanEnvironments/mobile/opacity-50/shoppingAreas.svg": "27f6",
	"./urbanEnvironments/mobile/opacity-50/sportFacilities.svg": "5982",
	"./urbanEnvironments/mobile/opacity-50/streets.svg": "2d6b",
	"./urbanEnvironments/parkings.svg": "0d23",
	"./urbanEnvironments/publicTransport.svg": "d07b",
	"./urbanEnvironments/schoolUniversities.svg": "07e1",
	"./urbanEnvironments/shoppingAreas.svg": "1e56",
	"./urbanEnvironments/sportFacilities.svg": "4033",
	"./urbanEnvironments/streets.svg": "9d52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "365c";